define('widgets/time',[
	'jquery',
	'lib/jquery-ui/widget'
], function ($) {

	return $.widget('muse.time', {

		options: {
		},

		_create: function () {


			return this._super();

		}

	});

});
